export default __webpack_public_path__ + "26e7f8b8d6eae6ce45205422b98eb6e2.png";